import React from "react";
import { observer } from "mobx-react";
import { FacilityOrderTemplateEditTemplate } from "themes/application/facility-order/pages";
import { FacilityOrderTemplateEditViewStore } from "application/facility-order/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new FacilityOrderTemplateEditViewStore(rootStore), "facilityOrderTemplateEditViewStore")
@observer
class FacilityOrderTemplateEdit extends React.Component {
	render() {
		return <FacilityOrderTemplateEditTemplate {...this.props} />;
	}
}

export default FacilityOrderTemplateEdit;